import script from "./FAQQuestion.vue?vue&type=script&setup=true&lang=js"
export * from "./FAQQuestion.vue?vue&type=script&setup=true&lang=js"

import "./FAQQuestion.vue?vue&type=style&index=0&id=17300248&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17300248"]])

export default __exports__